export default function getAppRootUrlFromProcess() {
    return '/';
    // return process.env.PUBLIC_URL || '/';
}



// WEBPACK FOOTER //
// ./src/helpers/getAppRootUrlFromProcess.js